import {ValidacaoService} from './../../service/validacao.service';
import {NgForm} from '@angular/forms';
import {PesquisasFiltroApiService} from './../../service/api/pesquisas-filtro.api';
import {GlobalService} from './../../service/global.service';
import {ModalService} from './../../service/modal.service';
import {FTA, Evento, EventoParametros, Cliente, Parametro, ParametrosEntradaEvento} from './../../model/catalogo';
import {Component, OnInit, Output, EventEmitter, Input, Injectable, ViewChild, HostListener} from '@angular/core';

import {FtaService} from '../../service/fta.service';
import {WizardComponent} from 'angular-archwizard';
import {JQueryStatic} from 'jquery';
import {HttpClient} from '@angular/common/http';

declare var $: JQueryStatic;

@Component({
    selector: 'app-detalhe-evento-parametros',
    templateUrl: './detalhe-evento-parametros.component.html',
    styleUrls: ['./detalhe-evento-parametros.component.css'],
    providers: [ValidacaoService]
})


@Injectable()
export class DetalheEventoParametrosComponent implements OnInit {

    constructor(
        public globalService: GlobalService,
        public pesquisaService: PesquisasFiltroApiService,
        public ftaService: FtaService,
        public http: HttpClient,
        private validacaoService: ValidacaoService,
        @ViewChild(WizardComponent)
        public wizard: WizardComponent
    ) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13 && this.novoEventoParametros != undefined && $('#modalEvento').hasClass('in')) {
                this.finishFunction();
            }
        }
    }

    parmParametros: Array<Parametro> = new Array<Parametro>();
    parametros: EventoParametros = new EventoParametros();
    addParametros: Array<ParametrosEntradaEvento> = new Array<ParametrosEntradaEvento>();
    cliente: Cliente = new Cliente();
    clienteAutorizacaoExtra: Cliente = new Cliente();

    @Output() parametrosAdicionada = new EventEmitter();
    @Output() eventoAlterado = new EventEmitter();
    @Output() eventoCancelado = new EventEmitter();

    @Input() novoEventoParametros: EventoParametros;
    @Input() evento: Evento;
    @Input() fta: FTA;

    chaveComposta: any;

    usuarioSelecionado: any;

    listaItens: Array<EventoParametros> = new Array<EventoParametros>();
    listaParametro: Array<Parametro> = new Array<Parametro>();

    eventoSelecionado: boolean = false;
    eventoLocal: Evento;
    selectedRange: any;
    caracteresInvalidos: string = '';

    resultadoUsuario: any;
    pesquisado: boolean = false;

    nomeParametroEntrada: string;
    descricaoParametroEntrada: string;
    nomeTipoDado: string;
    nomeSubtipoDado: string;
    nomesSubtipoDados: any;
    obrigatorio: boolean;

    paginaAtual: number = 1;
    pagina: number = 1;

    ngOnInit() {
    }

    // Um método de retorno uma chamada que executa a detecção de alterações
    ngDoCheck(): void {
        if (this.novoEventoParametros != undefined) {
            this.parametros = new EventoParametros();
            this.parametros = this.novoEventoParametros;
            this.parmParametros = this.novoEventoParametros.parmParametros;
            this.parametrosAdicionada.emit(this.parametros);
        }
    }

    finishFunction() {
        if (this.validacaoService.validaEvento(this.eventoLocal)) {
            //limpa campo de parametros
            this.selectedRange = '';
            this.eventoSelecionado = false;
            this.eventoAlterado.emit(true);
            this.wizard.navigation.reset();
        }
    }

    cancelarEvento() {
        //limpa campo de parametros
        this.selectedRange = '';
        this.eventoSelecionado = false;
        this.eventoCancelado.emit(this.evento);
    }

    adicionarParametros() {

        let json = {
            nomeParametroEntrada: this.nomeParametroEntrada,
            descricaoParametroEntrada: this.descricaoParametroEntrada,
            nomeTipoDado: this.nomeTipoDado,
            nomeSubtipoDado: this.nomeSubtipoDado,
            obrigatorio: this.obrigatorio
        };

        if (!this.nomeParametroEntrada || !this.descricaoParametroEntrada || !this.nomeTipoDado) {
            $.confirm({
                title: 'Atenção!',
                content: 'Campos obrigatorios <b>Nome/ Descrição/ Tipo</b>',
                type: 'red',
                buttons: {
                    ok: {
                        btnClass: 'btn-blue'
                    }
                },
                onClose: () => {

                }
            });
            return;
        }

        for (let i = 0; i <= this.evento.parametrosEntradaEvento.length; i++) {
            if (this.evento.parametrosEntradaEvento[i]) {
                if (this.evento.parametrosEntradaEvento[i].nomeParametroEntrada == this.nomeParametroEntrada) {
                    $.confirm({
                        title: 'Atenção!',
                        content: 'Não é possível iserir parâmetros com mesmo nome !',
                        type: 'red',
                        buttons: {
                            ok: {
                                btnClass: 'btn-blue'
                            }
                        },
                        onClose: () => {

                        }
                    });
                    return;
                }
            }
        }

        this.evento.parametrosEntradaEvento.push(json);
        this.parametrosAdicionada.emit(this.evento.parametrosEntradaEvento);
    }


    removerParametros(nome: string) {
        var lista = [];

        for (let i = 0; i <= this.evento.parametrosEntradaEvento.length; i++) {
            if (this.evento.parametrosEntradaEvento[i]) {
                if (this.evento.parametrosEntradaEvento[i].nomeParametroEntrada != nome) {
                    lista.push(this.evento.parametrosEntradaEvento[i]);
                }
            }
        }

        this.evento.parametrosEntradaEvento = lista;
    }

    onSubmit(f: NgForm) {
        f.reset();
    }


}



// WEBPACK FOOTER //
// ./src/app/detalhe-evento-parametros/detalhe-evento-parametros.component.ts